import React, {useState} from "react";

// Services
import {useIntl, FormattedMessage} from "react-intl";
import AuthenticationService from "../../../services/AuthenticationService";

// UI
import {PageHeading} from "../../Container";
import FaqList from "./FaqList";
import Button from "../../Button";
import Modal from "../../Modal";
import DialogTicket from "./DialogTicket";


function Support() {
  const intl = useIntl();

  const [showAdd, setShowAdd] = useState(false);
  const [showSuccessResponse, setShowSuccessResponse] = useState(false);
  const toggleOpenDialog = () => setShowAdd(!showAdd);
  const scopes = AuthenticationService.getUserScopes();
  const showCustomerPortal = scopes.indexOf("ticket:read") >= 0;

  return (
    <div>
      <PageHeading
        title={intl.formatMessage({id: "support"})}
        contentActions={
          <div className="flex items-center gap-5">
            <Button className="w-32 whitespace-nowrap" onClick={toggleOpenDialog}>
              <FormattedMessage id="button_faq"/>
            </Button>
            {showCustomerPortal ?
            <a href="https://knowledge.ammagamma.com/" target="blank">
              {intl.formatMessage({id: "hubspot_portal"})}
            </a> : null}
          </div>
        }
      />
      <FaqList/>
      <DialogTicket
        opened={showAdd}
        toggleOpen={toggleOpenDialog}
        setShowSuccessResponse={setShowSuccessResponse}
      />
      <Modal
        opened={showSuccessResponse}
        buttonText="Test Modal"
        title="Grazie!"
        description={intl.formatMessage({id: 'success_ticket_sent'})}
        onExit={() => {setShowSuccessResponse(false)}}
      />
    </div>
  );
}

export default Support;
